{{#if active}}
    <ul class="gHeader-nav-list">
        {{#each children}}
            {{> gHeaderNavItem }}
        {{/each}}
    </ul>
{{/if}}
